import { render, staticRenderFns } from "./PlayerSettingsModal.vue?vue&type=template&id=52d1757f&"
import script from "./PlayerSettingsModal.vue?vue&type=script&lang=js&"
export * from "./PlayerSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports